import { Grid, TextField } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import { addInfantesAction, addItemsAction } from "../../../../../ducks/cotizadorPaqueteDuck"
import { ToastMessage } from "../../../../../global/ToastMessage"
import { catTipoPlaza } from "../../../../../constant/catTipoPlaza"
import { catTipoItem } from "../../../../../constant/catTipoItem"

const FieldInfantes = () => {
    const { fechaSalida, cantidadAdultos, cantidadInfantes, clavePaquete, listaItems, listaHabitaciones, paquete } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        const newCantidadPasajeros = event.target.value
        const supHabitacion = listaHabitaciones.find(plaza => plaza.IdTipoPlaza === catTipoPlaza.INFANTE)
        if (!supHabitacion) {
            ToastMessage.fire({
                icon: "info",
                title: "No hay habitacion de menores para este paquete",
            })
            return null
        }
        if (Number(newCantidadPasajeros) < 0) {
            ToastMessage.fire({
                icon: "info",
                title: "La cantidad de pasajeros debe ser mayor o igaul a 1",
            })
            return null
        }
        if (Number(cantidadAdultos) < 2) {
            ToastMessage.fire({
                icon: "info",
                title: "Para agregar un infante tienes que agregar por lo menos dos adultos",
            })
            return null
        }
        // if (listaItems.find(item => item.name === "Sencilla")) {
        //     ToastMessage.fire({
        //         icon: "info",
        //         title: "No se puede agregar mas pasajeros, plaza Sencilla",
        //     })
        //     return null
        // }
        // if (listaItems.find(item => item.name === "Compartida")) {
        //     ToastMessage.fire({
        //         icon: "info",
        //         title: "No se puede agregar mas pasajeros, plaza Compartida",
        //     })
        //     return null
        // }
        let arrayItems = [...listaItems]
        arrayItems = listaItems.filter(item => item.type !== catTipoItem.PLAZAI && item.type !== catTipoItem.PLAZA)
        if (newCantidadPasajeros >= 1) {
            let itemHabitacion = {
                id: supHabitacion.IdObjeto,
                name: `${supHabitacion.Descripcion}`,
                price: supHabitacion.Suplemento,
                currency: paquete.Moneda?.Clave,
                type: catTipoItem.PLAZAI,
                quantity: newCantidadPasajeros
            }
            arrayItems.push(itemHabitacion)
        }
        dispatch(addInfantesAction({ cantidad: newCantidadPasajeros }))
        dispatch(addItemsAction({ listaItem: arrayItems }))
    }
    return (
        <Grid container>
            <Grid item xs={12}>
                <TextField
                    disabled={clavePaquete === "0" || fechaSalida === "0,0,0"}
                    value={cantidadInfantes}
                    style={{ width: "95%", margin: "0.5rem 0" }}
                    id={`outlined-number-Infantes`}
                    label="Infantes"
                    name="infantes"
                    onChange={handleChange}
                    type="number"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        inputProps: { min: 0, max: 10 }
                    }}
                    variant="outlined"
                />
            </Grid>
        </Grid>
    )
}
export default FieldInfantes